import React from 'react';
import PropTypes from 'prop-types';

import Section from '../../common/Section';
import Hero from './Hero';
import Anchor from '../utils/Anchor';

const HeroBlock = ({ content }) => {
  const { blockId } = content;

  return (
    <React.Fragment>
      <Anchor id={blockId} />
      <Section>
        <Hero content={content} />
      </Section>
    </React.Fragment>
  );
};

HeroBlock.propTypes = {
  content: PropTypes.object,
};

export default HeroBlock;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/heroBlock/HeroBlock.js